"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var react_native_table_component_1 = require("react-native-table-component");

var section_view_1 = require("../../../../components/primitives/section-view");

var constants_1 = require("../../../../theming/pricing-system/constants");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var button_1 = require("../../buttons/button/button");

var heading_1 = require("../../text/heading/heading");

var PricingTable = function (_super) {
  __extends(PricingTable, _super);

  function PricingTable() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PricingTable.prototype.render = function () {
    return react_1.default.createElement(section_view_1.SectionView, {
      style: [theme_pricing_system_1.pricingStyles.tableViewStyle, this.props.style]
    }, this.renderCaption(), this.renderButtons(), react_1.default.createElement(react_native_table_component_1.Table, null, react_1.default.createElement(react_native_table_component_1.Row, {
      data: this.props.headerData,
      style: theme_pricing_system_1.pricingStyles.tableHeaderRowViewStyle,
      textStyle: [theme_pricing_system_1.pricingStyles.tableHeaderCellTextStyle, this.props.textStyle],
      widthArr: this.props.columnWidths
    }), this.renderBody()), this.renderFooter());
  };

  PricingTable.prototype.renderCaption = function () {
    if (!this.props.caption) {
      return null;
    }

    return react_1.default.createElement(heading_1.Heading, {
      level: 2,
      textStyle: theme_pricing_system_1.pricingStyles.tableCaptionTextStyle
    }, this.props.caption);
  };

  PricingTable.prototype.renderButtons = function () {
    var _this = this;

    var buttons = this.props.buttons;

    if (!buttons) {
      return null;
    }

    return react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.tableActionsViewStyle
    }, buttons.map(function (button, index) {
      return _this.renderButton(button, index);
    }));
  };

  PricingTable.prototype.renderButton = function (action, key) {
    return react_1.default.createElement(button_1.Button, {
      key: key,
      textStyle: theme_pricing_system_1.pricingStyles.tableActionsTextStyle,
      label: action.text,
      onPress: action.onPress
    });
  };

  PricingTable.prototype.renderBody = function () {
    if (this.props.bodyData.length === 0) {
      return this.renderEmptyTableText();
    } else {
      return this.renderBodyRows();
    }
  };

  PricingTable.prototype.renderEmptyTableText = function () {
    var emptyTableText = this.props.emptyTableText ? this.props.emptyTableText : constants_1.PricingTableEmptyText;
    return react_1.default.createElement(react_native_table_component_1.Row, {
      style: theme_pricing_system_1.pricingStyles.tableEmptyViewStyle,
      textStyle: theme_pricing_system_1.pricingStyles.tableEmptyTextStyle,
      data: [emptyTableText]
    });
  };

  PricingTable.prototype.renderBodyRows = function () {
    var _this = this;

    var bodyData = this.props.bodyData;
    var rowCount = bodyData.length;
    return react_1.default.createElement(react_1.default.Fragment, null, bodyData.map(function (data, index) {
      return _this.renderBodyRow(data, index, rowCount);
    }));
  };

  PricingTable.prototype.renderBodyRow = function (data, index, rowCount) {
    var rowViewStyle = this.getBodyRowStyle(index, rowCount);
    return react_1.default.createElement(react_native_table_component_1.Row, {
      key: index,
      data: data,
      style: rowViewStyle,
      textStyle: [theme_pricing_system_1.pricingStyles.tableBodyCellTextStyle, this.props.textStyle],
      widthArr: this.props.columnWidths
    });
  };

  PricingTable.prototype.getBodyRowStyle = function (index, rowCount) {
    var rowStyles = [theme_pricing_system_1.pricingStyles.tableRowViewStyle];
    var isFirstRow = index === 0;

    if (isFirstRow) {
      rowStyles.push(theme_pricing_system_1.pricingStyles.tableFirstRowViewStyle);
    }

    var isLastRow = index === rowCount - 1;

    if (isLastRow) {
      rowStyles.push(theme_pricing_system_1.pricingStyles.tableLastRowViewStyle);
    }

    var isOddRow = index % 2 !== 0;

    if (isOddRow) {
      rowStyles.push(theme_pricing_system_1.pricingStyles.tableOddRowExtraViewStyle);
    }

    return rowStyles;
  };

  PricingTable.prototype.renderFooter = function () {
    var rowCount = this.props.bodyData.length;

    if (!this.props.footer || rowCount === 0) {
      return null;
    }

    var propsFooter = this.props.footer;
    var footerContent = typeof propsFooter === 'function' ? propsFooter(rowCount) : propsFooter;
    return react_1.default.createElement(react_native_1.View, null, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.tableFooterTextStyle
    }, footerContent));
  };

  return PricingTable;
}(react_1.default.Component);

exports.PricingTable = PricingTable;